// 万屋（里から開く札）。品物（材木・ガチャ券・錬成札）は買うたびに値上がりし、日付が変わると戻る。道具は一度買えばずっと使える解放。
// 表示は Profile から core の関数で計算し、買ったら /api/me を取り直して描き直す。
import { BATTLE_CONFIG, ITEM_UNLOCK, shopGoods, shopItems, type ShopGoodId } from '@hyakki/core';
import { sfx } from '../audio';
import { api } from '../api';
import { battleItemArt } from '../assets';
import { act, state } from '../state';
import { esc, fmt, jstDay } from './dom';
import { icon } from './icons';
import { openModal, toast } from './overlay';
import { errorText } from './status';

const GOOD_ICON: Record<ShopGoodId, string> = { zaimoku: 'ri-zaimoku', kuji: 'ri-kuji', fuse: 'ri-ticket' };

function html(): string {
  const p = state.profile;
  if (!p) return '';
  const zeni = state.resources.zeni ?? 0;
  const goods = shopGoods(p, jstDay());
  const items = shopItems(p).filter((x) => x.id !== 'heal');
  return `<div class="yz-wallet"><i class="ri ri-zeni"></i><b>${fmt(zeni)}</b></div>
    <ul class="yz-goods">${goods
      .map(
        (g) => `<li class="yz-good">
        <i class="ri ${GOOD_ICON[g.id]} yz-gi"></i>
        <span class="yz-gn"><b>${esc(g.name)}</b><small>×${fmt(g.amount)}</small></span>
        <span class="yz-gc">${g.daily ? `${g.bought}/${g.daily}` : g.bought ? `今日${g.bought}回` : ''}</span>
        <button class="btn primary yz-buy" data-good="${g.id}" ${g.soldOut || zeni < g.price ? 'disabled' : ''}>${g.soldOut ? '売り切れ' : `<i class="ri ri-zeni"></i>${fmt(g.price)}`}</button>
      </li>`,
      )
      .join('')}</ul>
    <h3 class="yz-h">道具</h3>
    <ul class="yz-items">${items
      .map((x) => {
        const d = BATTLE_CONFIG.items[x.id];
        const btn = x.owned
          ? `<span class="yz-owned">${icon('check')}解放済み</span>`
          : x.available
            ? `<button class="btn primary yz-buy" data-item="${x.id}" ${zeni < x.price ? 'disabled' : ''}><i class="ri ri-zeni"></i>${fmt(x.price)}</button>`
            : `<span class="yz-lock">${icon('lock')}主Lv${ITEM_UNLOCK[x.id]}</span>`;
        return `<li class="yz-item ${x.owned ? 'owned' : ''} ${x.available || x.owned ? '' : 'locked'}" title="${esc(d.desc)}">
          <span class="it-art yz-art" style="${battleItemArt(x.id)}"></span>
          <span class="yz-in"><b>${esc(d.name)}</b><small>${esc(d.desc)}</small></span>${btn}</li>`;
      })
      .join('')}</ul>`;
}

export function openYorozuya() {
  const m = openModal(`<div class="yz">${html()}</div>`, { title: '万屋', className: 'sheet-wrap navy-sheet yz-wrap' });
  const body = m.body.querySelector<HTMLElement>('.yz')!;
  m.body.addEventListener('click', async (e) => {
    const b = (e.target as HTMLElement).closest<HTMLButtonElement>('.yz-buy');
    if (!b || b.disabled) return;
    body.querySelectorAll<HTMLButtonElement>('.yz-buy').forEach((x) => (x.disabled = true));
    try {
      const target = b.dataset.good ? { good: b.dataset.good } : { item: b.dataset.item! };
      await act(api.buyYorozuya(target));
      sfx('coin');
      if (b.dataset.item) toast(`${BATTLE_CONFIG.items[b.dataset.item as keyof typeof BATTLE_CONFIG.items].name}を解放しました`, 'good');
    } catch (err) {
      toast(errorText(err), 'error');
    }
    body.innerHTML = html();
  });
}
